import { ReactElement, ReactNode } from 'react';

import { ToggleHelperContainer } from 'containers/ToggleHelperContainer';

type Props = {
  html: string;
  truncatedHtml: string;
  render: (args: {
    truncated: boolean;
    truncatedHtml: string;
    showAll: boolean;
    toggleShowAll: () => void;
  }) => ReactNode;
  alwaysTruncate?: boolean;
};

export function TruncatedHtml({
  html,
  truncatedHtml,
  render,
  alwaysTruncate,
}: Props): ReactElement {
  if (html === truncatedHtml || (!truncatedHtml && !alwaysTruncate)) {
    return (
      <>
        {render({
          truncated: false,
          truncatedHtml,
          showAll: true,
          toggleShowAll: () => {},
        })}
      </>
    );
  }

  return (
    <ToggleHelperContainer>
      {(showAll, toggleShowAll) =>
        render({
          truncated: true,
          truncatedHtml,
          showAll,
          toggleShowAll,
        })
      }
    </ToggleHelperContainer>
  );
}
